import React from 'react';

export default function Input({ label, error, className = '', ...props }) {
  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      {label && <label className="text-sm font-medium text-dark-green">{label}</label>}
      <input 
        className="px-4 py-2 rounded-md border border-amber bg-cream focus:outline-none focus:ring-2 focus:ring-forest-green transition-all"
        {...props}
      />
      {error && <span className="text-xs text-red-500">{error}</span>}
    </div>
  );
}